module.exports = require("@toruslabs/openlogin-jrpc");